import { PaymentBillsForm } from 'components/forms';


const AddPaymentBills = () => (
  <PaymentBillsForm />
);

export default AddPaymentBills;